module.exports = __webpack_public_path__ + "static/media/Åtte.b412ef7f.PNG";